import { render, staticRenderFns } from "./vueJsonCompare.vue?vue&type=template&id=54b1b2a5&"
import script from "./vueJsonCompare.vue?vue&type=script&lang=js&"
export * from "./vueJsonCompare.vue?vue&type=script&lang=js&"
import style0 from "./vueJsonCompare.vue?vue&type=style&index=0&id=54b1b2a5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports